import React from 'react';
import themeDark from "../../../shared/themeDark";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Button, IconButton } from "@material-ui/core";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from "react-hook-form";
import YellowBox from './YellowBox';
import CloseIcon from '@material-ui/icons/Close';

interface AmbulanceDialogPage3Props {
    setPage: any,
    endCallout: any,
    cancelEndCallout: any,
    calloutReasonValuesObj: any
};

const useStyles = makeStyles((theme) => ({
    typoHead: {
        fontSize: 46,
        fontWeight: 700,
        color: "#FFF",
    },
    label: {
        fontSize: 30,
    },
    input: {
        height: 95,
        color: "#FFF",
    },
    icon: {
        color: 'white'
    },
    topContainer:{
        display: 'flex',
        justifyContent:'space-between'
    },
    iconButton:{
        padding:0
    }
}));


const AmbulanceDialogPage3: React.FC<AmbulanceDialogPage3Props> = ({
    setPage,
    endCallout,
    cancelEndCallout,
    calloutReasonValuesObj
}) => {
    const { handleSubmit, errors, control, getValues, setError } = useForm();
    const classes = useStyles();

    const goBack = () =>{
        if(calloutReasonValuesObj?.calloutReason){
            setPage(2);
        }else{
            setPage(1);
        }
    }

    const submitValues = () => {
        const valuesObj = getValues();
        if(valuesObj.transferdViaAmbulance === "no" && !valuesObj.notes){
            setError('notes', {message:"Notes are required"});
            return;
        }
        endCallout(valuesObj);
    }

    return (
        <MuiThemeProvider theme={themeDark}>
            <Paper
                style={{
                    height: "100vh",
                    overflowY: "scroll",
                    padding: "57px 74px",
                    borderRadius: 0,
                }}
            >
                <div className={classes.topContainer}>
                    <span>
                        <Button style={{ padding: 0, minWidth: 0, color: "#FFF", marginBottom: 50, marginLeft: -6 }} onClick={goBack} ><KeyboardArrowLeftIcon /></Button>
                    </span>
                    <span>
                        <IconButton
                            aria-label="close"
                            className={classes.iconButton}
                            onClick={cancelEndCallout}>
                            <CloseIcon className={classes.icon} />
                        </IconButton>
                    </span>
                </div>

                <Typography variant="body1" component="div" className={classes.typoHead}>
                    Was the patient transferred to hospital via ambulance?
                </Typography>
                <form onSubmit={handleSubmit(submitValues)} autoComplete="off" >
                    <div style={{ display: "flex", width: "100%", marginTop: 40 }}>
                        <Controller
                            name='transferdViaAmbulance'
                            control={control}
                            render={(props) => (
                                <>
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <RadioGroup value={props.value ||""} onChange={props.onChange}>
                                            <FormControlLabel classes={{ label: classes.label }}
                                                value="yes" control={<Radio />} label="Yes"
                                            />
                                            <FormControlLabel classes={{ label: classes.label }}
                                                value="no" control={<Radio />} label="No"
                                            />
                                        </RadioGroup>
                                    </div>
                                </>
                            )}
                            rules={{ required: true }}
                        />
                    </div>
                    <Controller
                        name='notes'
                        defaultValue=''
                        control={control}
                        render={(props) => (
                            <TextField key='notes'
                                placeholder="Notes..."
                                variant="outlined"
                                multiline
                                rows={4}
                                InputProps={{
                                    classes: { input: classes.input },
                                }}
                                helperText={errors.notes ? "Notes are required" : ""}
                                style={{ marginTop: 42 }}
                                value={props.value}
                                onChange={props.onChange}
                                error={errors.notes}
                            />
                        )}
                    />
                    <div style={{ display: "flex", marginTop: 30, width: "100%", justifyContent: "flex-end" }}>
                        <YellowBox buttonProps={{ type: "submit" }} style={{ padding: "2px 0px" }} title="Done" />
                    </div>
                </form>
            </Paper>
        </MuiThemeProvider>
    );
}

export default AmbulanceDialogPage3;